import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';
import Main from '../components/Screens/Main';
import Section from '../components/Screens/Section';
import Spotlight from '../components/Screens/Spotlight';
import Markdown from '../components/Richtext/Markdown';
import PlayStore from '../../static/images/play_store.svg';
import AppStore from '../../static/images/app_store.svg';
import SocialLinks from '../components/Global/SocialLinks';
import Link from '../components/Global/Link';
import CardReview from '../components/Cards/CardReview';
import Carousel from '../components/Screens/Carousel';

// ====

const Game = (props) => {
  const { pageContext, blok } = props;
  let pageData;
  if (pageContext) {
    pageData = JSON.parse(pageContext.story.content);
  } else {
    pageData = blok;
  }
  const openGraph = {
    type: 'article',
    title: pageData.game_title,
    description: pageData.full_description,
    image: pageData.meta_image.filename,
    meta_fb_pages: pageData.meta_fb_pages,
  };

  return (
    <Layout
      meta={pageData.meta}
      openGraph={openGraph}
      image={
        pageData.image_hero_background &&
        pageData.image_hero_background.filename &&
        pageData.image_hero_background.filename
      }
      background="red"
    >
      <Hero
        title=""
        image={
          pageData.image_logo &&
          pageData.image_logo.filename &&
          pageData.image_logo.filename
        }
      />
      <Main>
        <Spotlight
          title={pageData.game_title}
          description={pageData.full_description}
          backgroundImage={
            pageData.image_description_background &&
            pageData.image_description_background.filename &&
            pageData.image_description_background.filename
          }
          marginBottom
        />

        <Section>
          <div className="col-12 brand-col">
            <Carousel
              video={pageData.vimeo && pageData.vimeo}
              images={pageData.gallery && pageData.gallery}
            />
            <div className="card">
              <div className="card-body brand-features-list">
                <h4 className="brand-font-caps">Game features</h4>
                <Markdown>{pageData.game_features}</Markdown>
              </div>
            </div>
          </div>
        </Section>

        <Section className="pt-3 pb-3">
          <div className="col-12 text-center">
            <ul className="list-unstyled list-inline">
              {pageData.app_store_link && (
                <li className="list-inline-item">
                  <a
                    href={pageData.app_store_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={AppStore}
                      alt="Download on the App Store"
                      width="150"
                      height="44"
                    />
                  </a>
                </li>
              )}

              {pageData.play_store_link && (
                <li className="list-inline-item">
                  <a
                    href={pageData.play_store_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={PlayStore}
                      alt="Download on the Play Store"
                      width="150"
                      height="44"
                    />
                  </a>
                </li>
              )}
            </ul>
          </div>
          <div className="col-12 text-center brand-font-size-2 brand-link-black">
            <SocialLinks
              links={[
                ['facebook', pageData.facebook_link.url],
                ['twitch', pageData.twitch_link.url],
                ['discord', pageData.discord_link.url],
                ['forums', pageData.forums_link.url],
                ['twitter', pageData.twitter_link.url],
                ['instagram', pageData.instagram_link.url],
                ['youtube', pageData.youtube_link.url],
              ]}
            />
          </div>

          {pageData.support_link && (
            <div className="col-12 text-center">
              <Link
                button
                icon
                newWindow
                to={pageData.support_link || pageData.support_link.url}
              >
                Game support
              </Link>
            </div>
          )}
        </Section>

        {pageData.reviews.length > 0 && (
          <Section>
            <div className="col brand-col">
              <div className="card">
                <div className="card-body brand-features-list">
                  <h4 className="brand-font-caps">Game reviews</h4>
                  <div className="brand-slider">
                    <ul className="brand-slider-container list-inline d-flex pt-3">
                      {pageData.reviews.map((item) => (
                        <CardReview
                          copy={item.copy}
                          reviewer={item.reviewer}
                          rating={item.rating}
                        />
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </Section>
        )}

        {pageData.legal_info && (
          <Section className="text-center small brand-text-grey pt-3 pb-3 pt-md-5 pb-md-5 pl-3 pr-3">
            <Markdown>{pageData.legal_info}</Markdown>
          </Section>
        )}
      </Main>
    </Layout>
  );
};

export default Game;

Game.propTypes = {
  pageContext: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Game.defaultProps = {
  pageContext: null,
  blok: null,
};
